module.exports = __webpack_public_path__ + "media/Bound of New Beginnings.9dc632ca.mp3";